import * as React from 'react';

const Info = () => (
  <svg width="1.5em" height="1.5em" viewBox="0 0 348 348" fill="none">
    <path
      d="M207 240h-11a21.997 21.997 0 01-15.556-6.444A21.997 21.997 0 01174 218v-55a11 11 0 00-11-11h-11"
      strokeWidth={22}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={168.5} cy={102.5} r={10.5} strokeWidth={19} />
    <path
      d="M174 338c90.575 0 164-73.425 164-164S264.575 10 174 10 10 83.425 10 174s73.425 164 164 164z"
      strokeWidth={22}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default React.memo(Info);
